import React from "react";
import { useFormik } from "formik";
import { LegalEntityAddFormValidation } from "./LegalEntityAddFormValidation";
import { ErrorToast, SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { client } from "../../../service/ApolloClient/ApolloClient";
import errorValidationApollo from "../../../utility/Forms/errorValidationApollo";
import { Box, Card, CardContent, Typography } from "@material-ui/core";

import {
  MUTATION_ADD_LEGAL_ENTITY,
  MUTATION_EDIT_LEGAL_ENTITY,
} from "../../../service/ApolloClient/ApolloMutation";
import { withRouter } from "react-router";

import LegalEntityAddFormFields from "./LegalEntityAddFormFields";
import Wrapper from "../../../hoc/Wrapper/Wrapper";

const validationSchema = LegalEntityAddFormValidation;

const LegalEntityAddForm = (props) => {
  const { data, isModal } = props;

  let valuesDefault = {
    name: "",
    email: "",
    website: "",
    phone: "",
    mobile: "",
    address: "",
    description: "",
    national_code: "",
    register_no: "",
  };

  if (props.isEdit) {
    valuesDefault = {
      ...valuesDefault,
      ...data,
      phone: JSON.parse(props.data.phone),
      mobile: JSON.parse(props.data.mobile),
    };
  }

  const formikData = useFormik({
    initialValues: valuesDefault,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      let newValue = values;

      submitHandle(newValue);
    },
  });

  const submitHandle = (values) => {
    setLoading(true);

    client
      .mutate({
        mutation: props.isEdit
          ? MUTATION_EDIT_LEGAL_ENTITY
          : MUTATION_ADD_LEGAL_ENTITY,
        variables: {
          ...values,
          phone: JSON.stringify(values.phone),
          mobile: JSON.stringify(values.mobile),
        },
      })
      .then((result) => {
        let legalEntity = props.isEdit
          ? result.data.editLegalEntity
          : result.data.addLegalEntity;
        if (legalEntity === null) {
          ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
          formikData.setErrors(
            errorValidationApollo({ title: "قادر به ثبت نمی باشد" }),
          );
        } else {
          SuccessToast("درخواست با موفقیت انجام شد ");
        }
        setLoading(false);
        if (isModal) {
          props.handleClose();
        } else {
          props.history.push("/legal-entity/edit/" + legalEntity.id);
        }
      })
      .catch((reason) => {
        ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
        formikData.setErrors(errorValidationApollo(reason));
        setLoading(false);
      });

    setLoading(true);
  };

  const [loading, setLoading] = React.useState(false);

  const component = (
    <Wrapper>
      {isModal ? null : (
        <Box ml={2} mb={2} display={"flex"}>
          <Box flexGrow={1} ml={1}>
            <Typography variant={"h5"} align={"left"}>
              {props.isEdit
                ? "ویرایش فرد حقوقی " + " " + props.data.id
                : "  افزودن فرد حقوقی"}
            </Typography>
          </Box>
        </Box>
      )}
      <LegalEntityAddFormFields
        loading={loading}
        isEdit={props.isEdit}
        {...formikData}
      />
    </Wrapper>
  );

  return isModal ? (
    component
  ) : (
    <Box mt={2}>
      <Card>
        <CardContent>{component}</CardContent>
      </Card>
    </Box>
  );
};

export default withRouter(LegalEntityAddForm);
